import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import {checkIfFlagIsToggled} from 'web-app/react/routes/debugger/local-storage-config';

export const completeImageUpload = (url, imageFor) => {
    return RESTClient.postAuthenticatedObservable('v2/images', {
        url,
        imageFor,
        useImagick: checkIfFlagIsToggled('ENABLE_IMAGICK_IMAGE_PROCESSING'),
    });
};

export const completeVideoUpload = url => {
    return RESTClient.postAuthenticatedObservable('v2/videos', {url});
};

export const completeFileUpload = (url, filename) => {
    return RESTClient.postAuthenticatedObservable('v2/files', {url, filename});
};

export const changeProfileImage = payload => {
    return RESTClient.postAuthenticatedObservable('v2/profileimages', {
        ...payload,
        useImagick: checkIfFlagIsToggled('ENABLE_IMAGICK_IMAGE_PROCESSING'),
    });
};

// Keeping export patterns
export {uploadFileObservable as uploadObservable} from './typed-api';
